<ng-container *transloco="let t; read: 'nav'">
  <div class="nav-bar__wrapper">
    <div
      class="nav-bar__top-bar"
      role="button"
      tabindex="0"
      [innerHTML]="t('topBar')"
      (click)="openTopBarUrl(t('topBarUrl'))"
      (keydown.enter)="openTopBarUrl(t('topBarUrl'))"
      (keydown.space)="
        $event.preventDefault(); openTopBarUrl(t('topBarUrl'))
      "></div>
    <div class="navBar">
      <a
        class="navBar__item"
        routerLink="/"
        fragment="whatIsGap"
        [class.active]="(activeFragment | async) === 'whatIsGap'">
        {{ t('home') }}
      </a>
      <a
        class="navBar__item"
        routerLink="/"
        fragment="benefits"
        [class.active]="(activeFragment | async) === 'benefits'">
        {{ t('how-it-works') }}
      </a>
      <a
        class="navBar__item"
        routerLink="/"
        fragment="forWho"
        [class.active]="(activeFragment | async) === 'forWho'">
        {{ t('types-of-policies') }}
      </a>
      <a
        class="navBar__item logo"
        routerLink="/"
        fragment="home"
        (click)="closeMenu()">
        <img
          src="assets/images/gap_logo.svg"
          alt="logo"
          class="logo"
          width="86"
          height="43" />
      </a>
      <a
        class="navBar__item"
        href="https://blog.gaponline.pl"
        rel="noopener noreferrer">
        {{ t('blog') }}
      </a>
      <a
        class="navBar__item"
        routerLink="/"
        fragment="faq"
        [class.active]="(activeFragment | async) === 'faq'">
        {{ t('faq') }}
      </a>
      <a
        class="navBar__item"
        routerLink="/"
        fragment="contact"
        [class.active]="(activeFragment | async) === 'contact'">
        {{ t('contact') }}
      </a>

      <ng-container *ngIf="!classicGap; else standardBuy">
        <button
          type="button"
          class="p-d-none p-d-xl-inline-block"
          [ngClass]="'buttonGreen'"
          (click)="redirectToWarrantiesApk()">
          <app-lock-open-icon class="nav-bar__lock-icon"></app-lock-open-icon>
          {{ t('buy-gap') }}
        </button>

        <button
          type="button"
          class="p-d-inline-block p-d-xl-none"
          [ngClass]="'buttonGreen'"
          (click)="redirectToWarrantiesApk()">
          <app-lock-open-icon class="nav-bar__lock-icon"></app-lock-open-icon>
          {{ t('buy-gap') }}
        </button>
      </ng-container>

      <ng-template #standardBuy>
        <a
          data-cy="nav-buy-gap-button"
          class="nav-buy-gap-button buttonYellow"
          routerLink="/cta/buy-gap"
          fragment="ctaHeader">
          <app-lock-open-icon class="nav-bar__lock-icon"></app-lock-open-icon>
          <span>{{ t('buy-gap') }}</span>
        </a>
      </ng-template>

      <a
        class="fbButton"
        target="_blank"
        href="https://www.facebook.com/ubezpieczeniaGAP/">
        <img
          class="p-mx-0 p-mt-1"
          src="assets/icons/fb-icon.svg"
          alt="bucket" />
      </a>
      <button
        type="button"
        class="p-d-xl-none menuToggle"
        [class.menuToggle--open]="isOpen"
        (click)="toggleMenu()"
        [attr.aria-expanded]="isOpen"
        aria-controls="nav-mobile-menu"
        [attr.aria-label]="isOpen ? 'Zamknij menu' : 'Otwórz menu'">
        <img
          *ngIf="!isOpen"
          src="assets/icons/menu.svg"
          alt="" />
        <img
          *ngIf="isOpen"
          src="assets/icons/cross.svg"
          alt="" />
      </button>
      <div
        *ngIf="isOpen"
        class="menuBackdrop p-d-xl-none"
        (click)="closeMenu()"></div>
      <div
        *ngIf="isOpen"
        id="nav-mobile-menu"
        class="menuList p-d-xl-none"
        role="dialog"
        aria-modal="true"
        aria-label="Menu">
        <a
          class="menuList__item"
          routerLink="/"
          fragment="whatIsGap"
          [class.active]="(activeFragment | async) === 'whatIsGap'"
          (click)="closeMenu()">
          {{ t('home') }}
        </a>
        <a
          class="menuList__item"
          routerLink="/"
          fragment="benefits"
          [class.active]="(activeFragment | async) === 'benefits'"
          (click)="closeMenu()">
          {{ t('how-it-works') }}
        </a>
        <a
          class="menuList__item"
          routerLink="/"
          fragment="forWho"
          [class.active]="(activeFragment | async) === 'forWho'"
          (click)="closeMenu()">
          {{ t('types-of-policies') }}
        </a>
        <a
          class="menuList__item"
          href="https://blog.gaponline.pl"
          rel="noopener noreferrer"
          (click)="closeMenu()">
          {{ t('blog') }}
        </a>
        <a
          class="menuList__item"
          routerLink="/"
          fragment="faq"
          [class.active]="(activeFragment | async) === 'faq'"
          (click)="closeMenu()">
          {{ t('faq') }}
        </a>
        <a
          class="menuList__item"
          routerLink="/"
          fragment="contact"
          [class.active]="(activeFragment | async) === 'contact'"
          (click)="closeMenu()">
          {{ t('contact') }}
        </a>
        <a
          data-cy="nav-buy-gap-button-mobile"
          class="menuList__buy"
          [ngClass]="(isWarranty$ | async) ? 'buttonGreen' : 'buttonYellow'"
          routerLink="/cta/buy-gap"
          fragment="ctaHeader"
          (click)="closeMenu()">
          <app-lock-open-icon class="nav-bar__lock-icon"></app-lock-open-icon>
          {{ t('buy-gap') }}
        </a>
      </div>
    </div>
  </div>
</ng-container>
